if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
        };
        if (!this.elements.viewer) return;

        // Listen for clicks on the gallery to intercept zoom buttons
        this.elements.viewer.addEventListener(
          "click",
          this.handleModalScroll.bind(this),
        );
      }

      handleModalScroll(event) {
        const modalOpener = event.target.closest("modal-opener");
        if (!modalOpener) return;

        const mediaItem = modalOpener.closest("[data-media-id]");
        if (!mediaItem) return;

        const mediaId = mediaItem.dataset.mediaId;
        const modalId = modalOpener.dataset.modal;
        const modal = document.querySelector(modalId);

        if (modal) {
          let attempts = 0;

          // Poll every 50ms until the modal is visibly rendered on the screen
          const checkVisibility = setInterval(() => {
            attempts++;
            const targetMediaInModal = modal.querySelector(
              `[data-media-id="${mediaId}"]`,
            );

            // offsetParent is not null ONLY when the element is visually rendered (not display: none)
            if (
              targetMediaInModal &&
              targetMediaInModal.offsetParent !== null
            ) {
              targetMediaInModal.scrollIntoView({
                behavior: "instant",
                block: "start",
              });

              // Clear the interval once the scroll is successfully executed
              clearInterval(checkVisibility);
            }

            // Failsafe: Stop checking after 1.5 seconds (30 attempts) to prevent infinite loops
            if (attempts >= 30) {
              clearInterval(checkVisibility);
            }
          }, 50);
        }
      }

      // Called externally (e.g. from product-info.js) when a variant/swatch is selected.
      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`,
        );
        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (
            activeMediaRect.top > -0.5 &&
            activeMediaRect.bottom < window.innerHeight
          )
            return;
          activeMedia.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        this.playActiveMedia(activeMedia);
        this.announceLiveRegion(activeMedia, activeMedia.dataset.mediaPosition);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector("img");
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position,
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }
    },
  );
}
